import { SimpleGrid, useDisclosure } from "@chakra-ui/react"
import { get } from "lodash"
import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { PROGRAM } from "../../../../consts/methods.consts"
import { PROGRAM_TAGS } from "../../../../consts/tags.consts"
import { useGetQuery } from "../../../../services/api.service"
import ChakraTable, { ChakraTableColumns } from "../../../common/chakra-table/ChakraTable"
import InnerLoading from "../../../common/inner-loading/InnterLoading"
import { PageHeaderActions } from "../../../common/page-header/PageHeader"
import { SectionCard } from "../../../common/section-card/SectionCard"
import { DefaultCellV2 } from "../../report/components/cells"
import StudentSelector from "./components/StudentSelectorModal"

const ProgramEnrollmentsTab = () => {
    const { id } = useParams()
    const [selectedItems, setSelectedItems] = useState([])
    const disclosure = useDisclosure()

    const { data: _data, isLoading, isFetching } = useGetQuery({
        method: PROGRAM.GET_PROGRAM_ENROLLMENTS,
        body: { id },
        providesTags: [PROGRAM_TAGS.MODULE_ENROLMENT]
    })

    const data = get(_data, 'message', {})
    const programModules = get(data, 'program_modules', [])
    const hasPermission = get(data, 'has_permission', false)


    const MODULE_ENROLLMENTS_COLUMNS: ChakraTableColumns = [
        {
            header: "Student ID",
            width: 200,
            accessor:
                "student",
            customRenderer: (value: any, item: any) => (
                React.createElement(DefaultCellV2, { navigateTo: `/app/student/${get(item, 'student')}`, value: value })
            ),
        },
        {
            header: "NIC",
            width: 500,
            accessor:
                "nic"
        },
        {
            header: "Full Name",
            width: 700,
            accessor:
                "full_name",
        },
    ]

    const modulesEnrollmentsMarkup = programModules.map((item: any) => {
        const enrollments = get(item, 'enrollments', [])
        const title = get(item, 'module_name', '')

        return (
            <ChakraTable title={title} size={"sm"} header
                columns={MODULE_ENROLLMENTS_COLUMNS} data={enrollments} />
        )
    })

    const actions: PageHeaderActions = [
        ...hasPermission ? [{
            text: "Enroll Students",
            onClick: disclosure.onOpen,
            buttonVariant: "solid",
            buttonColorScheme: "teal",
            confirmation: false
        }] : []
    ]

    return (

        <div>
            <SectionCard actions={actions} backgroundColor=" bg-white" title="Program Module Wise Enrollments" p={3}>
                {
                    (isLoading || isFetching) ? <div> <InnerLoading /></div> :
                        <SimpleGrid columns={{ base: 1 }} spacing={3}>
                            {modulesEnrollmentsMarkup}
                        </SimpleGrid>
                }

            </SectionCard>

            <StudentSelector
                isOpen={disclosure.isOpen}
                onClose={disclosure.onClose}
                parentData={{
                    program: id,
                }}
            />
        </div>

    )
}

export default ProgramEnrollmentsTab